import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import Vue from "vue";
import Vuex from "vuex";
import { SnackbarMessageStructure } from "@/shared/models/SnackbarMessageStructure";
import { FormsData } from "@/modules/Forms/models/FormsData";
import { MedicalOrderPreviewEventTimelineModel } from "@/modules/MedicalOrder/models/MedicalOrderPreviewEventTimelineModel";
import { ChatComunication } from "@/modules/Home/components/ChatWindow/Model/ChatComunication.model";
import { Utils } from "@/shared/utils/utils";
import { STORE_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import lodash from "lodash";
import { DASHBOARD_TEMPLATE_EMPTY } from "@/modules/DashboardTemplate/constants/DashboardTemplatesConstants";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    onSession: false,
    userId: "",
    role: "",
    userName: "",
    avatar: "",
    panelView: false,
    dataToMainView: {} as MenuDataStructure,
    dataToLateralMenu: {} as MenuDataStructure,
    refreshProfileServices: true,
    taskRefreshing: false,
    notifications: [],
    snackbarMessage: {} as SnackbarMessageStructure,
    profileCrumbs: {} as MenuDataStructure,
    onChangeServiceValidation: false,
    refreshTemplateService: false,
    generalDataTasks: [] as FormsData[],
    dashBoardSearchName: "",
    refreshGroupService: false,
    campusServiceTemplate: false,
    callOrigin: "",
    userState: "",
    medicalOrderValidation: false,
    medicalOrderObjList: {} as MedicalOrderPreviewEventTimelineModel,
    chatComunication: {} as ChatComunication,
    groupsLevels: [],
    medicalOrderStates: [],
    constantsUI: {},
    sectionsOfDashboardStore: ([
      {
        name: "",
        tags: [],
        indicators: [],
        collectionsOptions: [],
        collections: [
          {
            collection: [{ id: "", name: "", fields: [] }],
            filters: [],
            groupBy: [],
            seeBy: [],
            chartName: "",
            query: {},
            chartData: {}
          }
        ]
      }
    ] as unknown) as Array<SectionOfDashboard>,
    sectionsToChart: [],
    loadSomethingInDashboard: false,
    actionInFilters: {
      indexSection: 0,
      indexCollection: 0,
      indexFilter: 0,
      field: ""
    }
  },
  mutations: {
    changeSession(state, payload) {
      state.onSession = payload;
    },
    setUserId(state, payload) {
      state.userId = payload;
    },
    setPanelView(state, payload) {
      state.panelView = payload;
    },
    setRole(state, payload) {
      state.role = payload;
    },
    setUserName(state, payload) {
      state.userName = payload;
    },
    setAvatar(state, payload) {
      state.avatar = payload;
    },
    setDataToMainView(state, payload) {
      state.dataToMainView = payload;
    },
    setDataToLateralMenu(state, payload) {
      state.dataToLateralMenu = payload;
    },
    setRefreshProfileServices(state) {
      state.refreshProfileServices = !state.refreshProfileServices;
    },
    setTaskRefreshing(state, payload) {
      state.taskRefreshing = payload;
    },
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setSnackbarMessage(state, payload) {
      state.snackbarMessage = payload;
    },
    setProfileCrumbs(state, payload) {
      state.profileCrumbs = payload;
    },
    setOnChangeServiceValidation(state, payload) {
      state.onChangeServiceValidation = payload;
    },
    setRefreshTemplateService(state, payload) {
      state.refreshTemplateService = payload;
    },
    setGeneralDataTasks(state, payload) {
      state.generalDataTasks = payload;
    },
    setDashBoardNameSearch(state, payload) {
      state.dashBoardSearchName = payload;
    },
    setGroupServiceRefresh(state, payload) {
      state.refreshGroupService = payload;
    },
    setCampusServiceTemplate(state, payload) {
      state.campusServiceTemplate = payload;
    },
    setCallOrigin(state, payload) {
      state.callOrigin = payload;
    },
    setUserState(state, payload) {
      state.userState = payload;
    },
    setMedicalOrderValidation(state, payload) {
      state.medicalOrderValidation = payload;
    },
    setMedicalOrderObjList(state, payload) {
      state.medicalOrderObjList = payload;
    },
    setChatComunication(state, payload) {
      state.chatComunication = payload;
    },
    setGroupsLevels(state, payload) {
      state.groupsLevels = payload;
    },
    setOrderStates(state, payload) {
      state.medicalOrderStates = payload;
    },
    setConstantsUI(state, payload) {
      state.constantsUI = payload;
    },

    //--------------------sectionsOfDashBoard----------------------------
    setSectionsOfDashboard(state, payload) {
      state.sectionsOfDashboardStore.push(payload);
    },
    updateSectionsOfDashboard(state, payload) {
      state.sectionsOfDashboardStore = payload;
    },
    setCollectionsOptions(state, payload) {
      state.sectionsOfDashboardStore[payload.index].collectionsOptions =
        payload.collectionsOptions;
    },
    updateSectionNameOfDashboard(state, payload) {
      state.sectionsOfDashboardStore[payload.index].name = payload.name;
    },
    addCollectionToSectionOfDashboard(state, payload) {
      state.sectionsOfDashboardStore[payload.index].collections.push(
        payload.collection
      );
    },
    addFilter(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.index].filters.push(payload.onefilter);
    },

    deleteSectionOfDashboard(state, payload) {
      state.sectionsOfDashboardStore.splice(payload, 1);
    },
    deleteCollection(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections.splice(payload.index, 1);
    },
    deleteFilter(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollection].filters.splice(
        payload.indexFilter,
        1
      );
    },
    quitCollectionItemOptionAndPutInCollection(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collectionsOptions = state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collectionsOptions.filter(
        collection => collection.id !== payload.collection[0].id
      );

      if (
        state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
          .collections[payload.indexCollectionFilter].collection[0].id !== ""
      ) {
        state.sectionsOfDashboardStore[
          payload.indexSectionOfDashboard
        ].collectionsOptions = [
          ...state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
            .collectionsOptions,
          state.sectionsOfDashboardStore[payload.indexSectionOfDashboard]
            .collections[payload.indexCollectionFilter].collection[0]
        ];
      }

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].collection =
        payload.collection;

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].filters = [];
    },
    setCollectionItem(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collectionsOptions.push(payload.collection);
    },
    setFilterItem(state, payload) {
      console.log("setFilterItem", payload);

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollection].filters[payload.indexFilter] =
        payload.filter;
    },
    setConfigChart(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].groupBy = payload.groupBy;

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].seeBy = payload.seeBy;

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].chartName =
        payload.chartName;

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].chartData =
        payload.chartData;

      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].chartColor =
        payload.chartColor;
    },
    cleanAllDataOfDashboardTemplate(state) {
      state.sectionsOfDashboardStore = (lodash.cloneDeep(
        DASHBOARD_TEMPLATE_EMPTY
      ) as unknown) as Array<SectionOfDashboard>;
      state.sectionsToChart = [];
    },
    setTag(state, payload) {
      state.sectionsOfDashboardStore[payload.index].tags.push(payload.tag);
    },
    editTag(state, payload) {
      state.sectionsOfDashboardStore[payload.index].tags = payload.tags;
    },
    setIndicator(state, payload) {
      state.sectionsOfDashboardStore[payload.index].indicators.push(
        payload.indicator
      );
    },
    editIndicator(state, payload) {
      state.sectionsOfDashboardStore[payload.index].indicators =
        payload.indicators;
    },
    setQuery(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].query = payload.query;
    },
    setSectionsToChart(state, payload) {
      state.sectionsToChart = payload.sectionsToChart;
    },
    setChartType(state, payload) {
      state.sectionsOfDashboardStore[
        payload.indexSectionOfDashboard
      ].collections[payload.indexCollectionFilter].chartType =
        payload.chartType;
    },
    setLoadSomethingInDashboard(state, payload) {
      state.loadSomethingInDashboard = payload;
    },
    setActionInFilters(state, payload) {
      state.actionInFilters = payload;
    }
  },
  getters: {
    getDataToMainView: state => state.dataToMainView,
    getDataToLateralMenu: state => state.dataToLateralMenu,
    getRefreshProfileServices: state => state.refreshProfileServices,
    getPanelView: state => state.panelView,
    getTaskRefreshing: state => state.taskRefreshing,
    getNotifications: state => state.notifications,
    getSnackbarMessage: state => state.snackbarMessage,
    getProfileCrumbles: state => state.profileCrumbs,
    getOnChangeServiceValidation: state => state.onChangeServiceValidation,
    getRefreshTemplateService: state => state.refreshTemplateService,
    getGeneralDataTasks: state => state.generalDataTasks,
    getDashBoardNameSearch: state => state.dashBoardSearchName,
    getGroupServiceRefresh: state => state.refreshGroupService,
    getUserRole: state => state.role,
    getCampusServiceTemplate: state => state.campusServiceTemplate,
    getCallOrigin: state => state.callOrigin,
    getUserState: state => state.userState,
    getMedicalOrderValidation: state => state.medicalOrderValidation,
    getMedicalOrderObjList: state => state.medicalOrderObjList,
    getChatComunication: state => state.chatComunication,
    getGroupsLevels: state => state.groupsLevels,
    getOrderStates: state => state.medicalOrderStates,

    //sectionsOfDashBoard
    getSectionsOfdashboard: state => state.sectionsOfDashboardStore,
    getSectionsToChart: state => state.sectionsToChart,
    getLoadSomethingInDashboard: state => state.loadSomethingInDashboard,
    getActionInFilters: state => state.actionInFilters
  },
  actions: {
    async fetchConstantsUI({ commit }) {
      const constants = await Utils.getUIConfig();
      commit(STORE_CONSTANTS.SET_CONSTANTS_UI, constants);
    }
  },
  modules: {}
});
